if (window.quickAddSizeExecuted == false) {
    window.quickAddSizeExecuted = true;
    const fetchCardProduct = (productCard, productID) => {
      const productVariants = JSON.parse(productCard.dataset.variants);
      if (productVariants && productVariants != "") {
        if (productCard.querySelector('.card__quick-options'))
          productCard.querySelector('.card__quick-options').remove();
        if (productCard.querySelector('.card__quick-options')) return;

        const productFormHeader = document.createElement('div');
        productFormHeader.className = 'card__quick-header';
        const container = document.createElement('div');
        container.className = 'card__quick-options';
        container.className += ' card__options-modal';
        const productFormFooter = document.createElement('div');
        productFormFooter.className = 'card__quick-footer';
        
        if (productVariants.length === 1) {
          // container
          const variant = productVariants[0];
          const button = document.createElement('button');
          container.classList.add('card__default');
          button.className = 'button button--primary card__quick--option';
          button.textContent = window.variantStrings.addToCart;
          if (!variant.available) {
            button.disabled = true;
            button.textContent = window.variantStrings.soldOut;
          }
          button.dataset.variantId = variant.id;
          button.addEventListener('click', addToCart);
          container.appendChild(button);
          // header
          productFormHeader.classList.add("medium-hide", "large-up-hide");
          const headerTitle = document.createElement('span');
          headerTitle.className = 'low-s title';
          headerTitle.innerText = productCard.dataset.title;
          productFormHeader.appendChild(headerTitle);

          const productPrice = productCard.querySelector(".card-information > .price");
          const clonedProductPrice = productPrice.cloneNode(true);
          productFormHeader.appendChild(clonedProductPrice);

          container.insertBefore(productFormHeader, container.firstChild);
        } else {
          // container
          const buttonContainer = document.createElement('div');
          buttonContainer.classList.add('options__select-container');
          productVariants.forEach((variant) => {
            const button = document.createElement('button');
            button.className = 'card__quick--option';
            button.textContent = variant.option1;
            if (!variant.available) button.disabled = true;
            button.dataset.variantId = variant.id;
            button.addEventListener('click', addToCart);
            buttonContainer.appendChild(button)
          });
          container.appendChild(buttonContainer);

          // header
          const quickSelectText = document.createElement('span');
          quickSelectText.className = 'low-s light';
          quickSelectText.innerText = window.variantStrings.selectSize;
          productFormHeader.appendChild(quickSelectText);
          
          const selectOptionButton = document.createElement('button');
          selectOptionButton.className = 'button button--primary';
          if (productCard.dataset.soldout) {
            selectOptionButton.setAttribute("disabled", "");
            selectOptionButton.innerText = window.variantStrings.soldOut;
          } else {
            selectOptionButton.innerText = window.variantStrings.selectSize;
          }
          productFormFooter.appendChild(selectOptionButton);
          
          container.insertBefore(productFormHeader, container.firstChild);
          container.appendChild(productFormFooter);
        }

        let cardContainer = productCard.querySelector('.card__media');
        cardContainer?.insertAdjacentElement('afterend', container);
        if (window.matchMedia('(max-width: 749px)').matches) {

          const card = productCard.querySelector('.card');
          
          const cardClose = document.createElement('button');
          cardClose.className = 'card__quick--options-close card__options-close link full-unstyled-link';
          cardClose.innerHTML =
            '<svg class="icon icon-close" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.560981 10L0 9.43902L4.43902 5L0 0.560981L0.560981 0L5 4.43902L9.43902 0L10 0.560981L5.56098 5L10 9.43902L9.43902 10L5 5.56098L0.560981 10Z" fill="currentColor"/></svg>';
          productFormHeader.appendChild(cardClose);

          container.insertBefore(productFormHeader, container.firstChild);

          if (card.closest('.scroll-trigger.animate--slide-in'))
            card.closest('.scroll-trigger.animate--slide-in').classList.remove('scroll-trigger', 'animate--slide-in');
            
            container.classList.add('quick-select-open-mobile');
            document.body.classList.add('quick-select-open-mobile');
            document.body.appendChild(container)

            cardClose.addEventListener('click', (evt) => {
              evt.preventDefault()
              const optionsModalBody = document.querySelector('.quick-select-open-mobile.card__quick-options');
              optionsModalBody.classList.remove('quick-select-open-mobile');
              document.body.classList.remove('quick-select-open-mobile');
              optionsModalBody.remove();
            });
        }
        setTimeout(() => {
          productCard.classList.add('has-options');
        }, 50);

      } else {
        console.error("Empty variants")
      }
    };
  
    const addToCart = (event) => {
      event.preventDefault();
      const variantId = event.target.dataset.variantId;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          openCart();
          const optionsModalBody = document.querySelector('.quick-select-open-mobile.card__quick-options');
          if (optionsModalBody) {
            optionsModalBody.classList.remove('quick-select-open-mobile');
            document.body.classList.remove('quick-select-open-mobile');
            optionsModalBody.remove();
          }

        })
        .catch((error) => {
          const optionsModalBody = document.querySelector('.quick-select-open-mobile.card__quick-options');
          if (optionsModalBody) {
            optionsModalBody.classList.remove('quick-select-open-mobile');
            document.body.classList.remove('quick-select-open-mobile');
            optionsModalBody.remove();
          }
        });
    };
  
    const openCart = () => {
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart) {
        setTimeout(() => {
          cart.classList.add('animate', 'active');
        });
    
        if (cart.querySelector('.drawer__inner-empty')) cart.querySelector('.drawer__inner-empty').remove();
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['cart-drawer-items', '.drawer__footer'];
            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }
    
            const cartItemCountTab = document.getElementById('cart-items-count-tab');
            if (cartItemCountTab) {
              cartItemCountTab.innerText.trim()
              const count = parseInt(cartItemCountTab.innerText.trim(), 10) || 0; 
              const newCount = count + 1;
              document.getElementById('cart-items-count-tab').innerText = newCount;
            }
    
            const cartIconBubbleElement = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
            if (cartIconBubbleElement && cartIconBubbleElement.innerText) {
              const cartIconBubbleText = cartIconBubbleElement.innerText.trim();
      
              const matches = cartIconBubbleText.match(/(\D*)(\d+)(\D*)/);
              if (matches) {
                let countBubble = parseInt(matches[2], 10);
                countBubble += 1;
                const newCartIconBubble = `${matches[1]}${countBubble}${matches[3]}`;
                cartIconBubbleElement.innerText = newCartIconBubble;
              }
            }
            productCardsSizes();
          })
          .catch((e) => {
            console.error(e);
          });
    
        document.body.classList.add('overflow-hidden');
      }
    };
  
    function productCardsSizes() {
      const productCardWrappers = document.querySelectorAll('.product-card-wrapper:not(.product-card-bundle):not(.product-card-pack)');
  
      productCardWrappers.forEach((productCard) => {
        productCard.addEventListener('mouseenter', () => {
          if (window.matchMedia('(min-width: 750px)').matches) {
            productCard.classList.add('hovered');
  
            if (!productCard.classList.contains('is-executed') || !productCard.querySelector(".card__quick-options")) {
              productCard.classList.add('is-executed');
              const productID = productCard.getAttribute('data-product');
  
              fetchCardProduct(productCard, productID);
            }
          }
        });
  
        productCard.addEventListener('mouseleave', () => {
          if (window.matchMedia('(min-width: 750px)').matches) {
            productCard.classList.remove('hovered');
          }
        });
  
        productCard.querySelector('.card__quick-opener')?.addEventListener('click', () => {
          if (window.matchMedia('(max-width: 749px)').matches) {
            if (!document.querySelector(".card__options-modal")) {
              productCard.classList.remove('hovered');
              const productID = productCard.getAttribute('data-product');
              fetchCardProduct(productCard, productID);
            }
          }
        });
  
      });
    }
  
    productCardsSizes();
  }
  